module.exports = __webpack_public_path__ + "static/img/member_list_5.1c666c7f.png";